import { render, staticRenderFns } from "./FormCardProfileAggregate.vue?vue&type=template&id=68b5e646"
import script from "./FormCardProfileAggregate.vue?vue&type=script&lang=js"
export * from "./FormCardProfileAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports